import styled from 'styled-components';
import { MEDIA } from '../../../constants/breakpoints';

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  background: transparent;
  position: relative;
  min-height: 0;
`;

export const ChatMessages__List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  min-height: min-content;

  ${MEDIA.MOBILE} {
    padding: 16px 12px;
    gap: 12px;
  }
`;

export const ChatMessages__ScrollAnchor = styled.div`
  height: 1px;
`;
